import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Keep the static first-paint shell (written into #root at build time) so the app can
// keep showing it while the first page's code is still loading.
(window as Window & { __SHELL_HTML__?: string }).__SHELL_HTML__ =
  document.getElementById('root')?.innerHTML || '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Render as a transition so React can split the first render into small chunks
// and keep the main thread responsive (the static shell stays visible meanwhile).
React.startTransition(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
